export function ClientStorage (name, engine = localStorage) {
  return {
    save (value) {
      try {
        const json = JSON.stringify(value);
        engine.setItem(name, json);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    load () {
      try {
        return JSON.parse(engine.getItem(name));
      } catch (e) {
        return null;
      }
    }
  };
}
